import { isLoggedIn, getIdToken, removeToken, getDataToken, getHeaderToken, getRoleId } from './user/token.js'
let CryptoJS = require("crypto-js")

export default {
    // data(){
    //     return{
    //         roleName: '',
    //     }
    // },
  items: [
    {
      title: true,
      name: localStorage.getItem('fullname') + ' (' +  localStorage.getItem('role_name') + ')',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Sales',
      url: '/salesmanagement',
      icon: 'icon-star'
    },
    {
      name: 'Customer',
      url: '/customermanagement',
      icon: 'icon-star'
    },
    {
      name: 'Report',
      url: '/report',
      icon: 'icon-star'
    },
    // {
    //   name: 'Dealer & Kios',
    //   url: '/collapses',
    //   icon: 'icon-puzzle'
    // },
    // {
    //   name: 'Customer',
    //   url: '/forms',
    //   icon: 'icon-puzzle'
    // },
    // {
    //   name: 'Add New Sales',
    //   url: '/base/salesform',
    //   icon: 'icon-puzzle'
    // },
    // {
    //   name: 'Login',
    //   url: '/pages/login',
    //   icon: 'icon-star'
    // },
    // {
    //   name: 'Forgot Password',
    //   url: '/pages/register',
    //   icon: 'icon-star'
    // },
  ],
  created(){

    //   var success = false
    //   const s = setInterval(() => {
    //       if (success == true){
    //           clearInterval(s)
    //           return
    //       }
    //       try{
    //         if ($('.sidebar-nav ul>li:first').length < 1){
    //             throw new Error('not found')
    //         }
    //          $('.sidebar-nav ul>li:first').html('test')
    //          success = true
    //       } catch (e) {
    //           console.log('retry')
    //       }
    //   }, 5000)
  },
  methods: {
    getRoleName(){

    }
  }
}
